module.exports = __webpack_public_path__ + "static/media/Bootstrap.d36447bb.bin";